import { render, staticRenderFns } from "./REAIPromptList.vue?vue&type=template&id=5864ecb9&scoped=true"
import script from "./REAIPromptList.vue?vue&type=script&lang=js"
export * from "./REAIPromptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864ecb9",
  null
  
)

export default component.exports